import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import CustomButton from "../CustomButton";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const WorkCulture = () => {
  const data = {
    list: [
      {
        icon: "/images/close-teams.svg",
        title: "Close Teams. Faster Results.",
        content: "Leverage nearshore solutions to bridge the gap between quality and efficiency while aligning with your goals."
      },
      {
        icon: "/images/innovation.svg",
        title: "Innovation Without Borders.",
        content: "Our nearshore teams bring global expertise with local understanding, enabling seamless collaboration"
      },
      {
        icon: "/images/scalability.svg",
        title: "Scalable Solutions. Instant Impact.",
        content: "Quickly adapt to changing business needs with agile and scalable nearshore models."
      },
      {
        icon: "/images/efficiency-redefined.svg",
        title: "Efficiency Redefined.",
        content: "Achieve high-quality results at reduced costs, delivered by teams that work in sync with your time zone."
      }
    ]
  }
  return (
    <div className="section-bg work-culture">
      <Container className="" >
        <Row className="cultures">
        {data.list?.map((item) => (
            <Col lg={3} md={6} className="">
               <img src={item.icon} alt="Close Teams Faster Results" />
               <h3>{item.title}</h3>
               <p>{item.content}</p>
            </Col>
        ))}
        </Row>
      </Container>
    </div>
  );
};

export default WorkCulture;
